import {
  DELETE_DEAL,
  DELETE_DEAL_SUCCESS,
  DELETE_DEAL_FAILURE,
  FETCH_DEAL_LIST,
  FETCH_DEAL_LIST_SUCCESS,
  FETCH_DEAL_LIST_FAILURE,
  PAGE_NUMBER,
  PAGE_TOTAL,
  RESET
} from './DealList.actions'

const initialState = {
  isLoading: false,
  deals: [],
  perPage: 50,
  pageNumber: 0,
  pageTotal: 1,
  errors: [],
  requestComplete: false
}

const currentState = (state = initialState, action) => {
  switch(action.type) {
    case DELETE_DEAL:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_DEAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requestComplete: true
      }
    case DELETE_DEAL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case FETCH_DEAL_LIST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_DEAL_LIST_SUCCESS:
      return {
        ...state,
        deals: action.payload,
        isLoading: false
      }
    case FETCH_DEAL_LIST_FAILURE:
      return {
        ...state,
        errors: action.payload,
        isLoading: false
      }
    case PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload
      }
    case PAGE_TOTAL:
      return {
        ...state,
        pageTotal: action.payload
      }
    case RESET:
      return {
        isLoading: false,
        errors: [],
        requestComplete: false
      }
    default:
      return state
  }
}

export default currentState;